export const updateAATagging = (obj, trackingScript) => {
    window.dataElement = {...window.dataElement, ...obj};
    if (window._satellite) {
        window._satellite.track(trackingScript);
    }
    // console.log(window.dataElement, trackingScript)
}

export const updateLanguageAATagging = (lang) => {
    switch(lang) {
        case 'EN': return 'en';
        case 'TH': return 'th';
        case 'ID': return 'bh';
        case 'MY': return 'bh';
        case 'CH': return 'zh';
        case 'default': return 'en';
    }
}